/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface CorrectRunClockResponse
 */
export interface CorrectRunClockResponse {
    /**
     * 
     */
    appliedDeltaSeconds: number;
    /**
     * 
     */
    eventsCorrected: number;
    /**
     * 
     */
    capturesCorrected: number;
    /**
     * 
     */
    newRunStart: Date | null;
    /**
     * 
     */
    newRunEnd: Date | null;
}

/**
 * Check if a given object implements the CorrectRunClockResponse interface.
 */
export function instanceOfCorrectRunClockResponse(value: object): value is CorrectRunClockResponse {
    if ((!('appliedDeltaSeconds' in (value as Record<string, any>)) && !('applied_delta_seconds' in (value as Record<string, any>))) || ((value as Record<string, any>)['appliedDeltaSeconds'] === undefined && (value as Record<string, any>)['applied_delta_seconds'] === undefined)) return false;
    if ((!('eventsCorrected' in (value as Record<string, any>)) && !('events_corrected' in (value as Record<string, any>))) || ((value as Record<string, any>)['eventsCorrected'] === undefined && (value as Record<string, any>)['events_corrected'] === undefined)) return false;
    if ((!('capturesCorrected' in (value as Record<string, any>)) && !('captures_corrected' in (value as Record<string, any>))) || ((value as Record<string, any>)['capturesCorrected'] === undefined && (value as Record<string, any>)['captures_corrected'] === undefined)) return false;
    if ((!('newRunStart' in (value as Record<string, any>)) && !('new_run_start' in (value as Record<string, any>))) || ((value as Record<string, any>)['newRunStart'] === undefined && (value as Record<string, any>)['new_run_start'] === undefined)) return false;
    if ((!('newRunEnd' in (value as Record<string, any>)) && !('new_run_end' in (value as Record<string, any>))) || ((value as Record<string, any>)['newRunEnd'] === undefined && (value as Record<string, any>)['new_run_end'] === undefined)) return false;
    return true;
}

export function CorrectRunClockResponseFromJSON(json: any): CorrectRunClockResponse {
    return CorrectRunClockResponseFromJSONTyped(json, false);
}

export function CorrectRunClockResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectRunClockResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appliedDeltaSeconds': json['applied_delta_seconds'],
        'eventsCorrected': json['events_corrected'],
        'capturesCorrected': json['captures_corrected'],
        'newRunStart': (json['new_run_start'] == null ? null : parseDateTime(json['new_run_start'])),
        'newRunEnd': (json['new_run_end'] == null ? null : parseDateTime(json['new_run_end'])),
    };
}

export function CorrectRunClockResponseToJSON(json: any): CorrectRunClockResponse {
    return CorrectRunClockResponseToJSONTyped(json, false);
}

export function CorrectRunClockResponseToJSONTyped(value?: CorrectRunClockResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applied_delta_seconds': value['appliedDeltaSeconds'],
        'events_corrected': value['eventsCorrected'],
        'captures_corrected': value['capturesCorrected'],
        'new_run_start': value['newRunStart'] == null ? value['newRunStart'] : serializeDateTime(value['newRunStart']),
        'new_run_end': value['newRunEnd'] == null ? value['newRunEnd'] : serializeDateTime(value['newRunEnd']),
    };
}

